// services/zone.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, firstValueFrom, from, Observable} from 'rxjs';
import { environment } from '../../environments/environment';
import {get} from "sortablejs";
import {Balance} from "../_models/cashier.model";

@Injectable({
    providedIn: 'root',
})
export class AgentService {
    private readonly API = `${environment.API_URL}/agencybanking`;
    public agentBalance!: Balance;

    constructor(private http: HttpClient) {}

    getAll(url:string): Observable<any> {
        return this.http.get(this.API+url);
    }

    getById(id: string): Observable<Zone> {
        return this.http.get<Zone>(`${this.API}/${id}`);
    }

    create(url:string,data?:any): Observable<any> {
        return this.http.post(this.API+url, data);
    }

    update(url:string,id: string, zone: Zone): Observable<Zone> {
        return this.http.put<Zone>(`${this.API+url}/${id}`, zone);
    }

    delete(id: string): Observable<void> {
        return this.http.delete<void>(`${this.API}/${id}`);
    }

    // initBalance(){
    //     this.create('/balance').subscribe((e)=>{
    //         // console.log('balance', e.data)
    //         this.agentBalance = e.data
    //     })
    // }

    private balanceSubject = new BehaviorSubject<any>(null);

    initBalance() {
        this.create('/balance').subscribe((res) => {
            this.balanceSubject.next(res.data);
        });
    }

    get balance$(): Observable<any> {
        return this.balanceSubject.asObservable();
    }
}
